export interface DurationOption {
  value: string;
  label: string;
  minutes: number;
}

export const defaultSessionForm = {
  title: '',
  batchId: '',
  startDate: '',
  startTime: '',
  notifyBatch: false,
  autoEndTest: true,
  aiProctoring: true,
  qaDurationMinutes: 10,
};

export const QA_DURATION_PRESETS = [5, 10, 15, 20, 30] as const;

export function formatDurationLabel(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

export function buildQaDurationOptions(): DurationOption[] {
  return QA_DURATION_PRESETS.map((minutes) => ({
    value: String(minutes),
    label: formatDurationLabel(minutes),
    minutes,
  }));
}

export function buildDurationOptions(plannerMinutes: number): DurationOption[] {
  const presets = [45, 55, 60, 90, 105, 120];
  const set = new Set<number>(
    plannerMinutes > 0 ? [plannerMinutes, ...presets] : presets,
  );
  return Array.from(set)
    .sort((a, b) => a - b)
    .map((minutes) => ({
      value: String(minutes),
      label: formatDurationLabel(minutes),
      minutes,
    }));
}
